export default __webpack_public_path__ + "static/media/desktop-banner.e72d7473.jpg";